import React, { useEffect } from 'react'
import { Container, Pagination, Containt } from './styles'
import { useTable, usePagination } from 'react-table'

interface TableProps {
  columns: any
  data: any
  /** Quando true, exibe todas as linhas sem barra de paginação (útil com paginação no servidor). */
  hidePagination?: boolean
}

export function Table({ columns, data, hidePagination = false }: TableProps) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: hidePagination ? Math.max(data?.length || 1, 1) : 10,
      },
    },
    usePagination,
  )

  useEffect(() => {
    if (hidePagination) {
      setPageSize(Math.max(data?.length || 1, 1))
    }
  }, [hidePagination, data, setPageSize])

  return (
    <Container>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {!hidePagination && (
      <Pagination>
        <Containt>
          <button type="button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '}
          <button type="button" onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
          </button>{' '}
          <button type="button" onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
          </button>{' '}
          <button type="button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '}
          <span>
            Página{' '}
            <strong>
              {pageIndex + 1} de {pageOptions.length}
            </strong>{' '}
          </span>
          <span>
            | ir para página:{' '}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const pageNum = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(pageNum)
              }}
              style={{ width: '100px' }}
            />
          </span>{' '}
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map(ps => (
              <option key={ps} value={ps}>
                Mostrar {ps}
              </option>
            ))}
          </select>
        </Containt>
      </Pagination>
      )}
    </Container >
  )
}
